/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Admin_3Inputs */

const da_privacy_admin_3 = /** @type {(inputs: Privacy_Admin_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvis du ikke selv kan komme ind, kan en administrator sende bekræftelsen eller mailen om ny adgangskode igen, markere din e-mailadresse som bekræftet eller lave et engangslink til en ny adgangskode, som sendes til dig. Det kræver en begrundelse og noteres i en log. Linket gemmes ikke.`)
};

/** @type {(inputs: Privacy_Admin_3Inputs) => LocalizedString} */
const en_privacy_admin_3 = da_privacy_admin_3;

/**

* @param {Privacy_Admin_3Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_admin_3 = /** @type {((inputs?: Privacy_Admin_3Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Admin_3Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_admin_3(inputs)
	return /** @type {LocalizedString} */ ("Hvis du ikke selv kan komme ind, kan en administrator sende bekræftelsen eller mailen om ny adgangskode igen, markere din e-mailadresse som bekræftet eller lave et engangslink til en ny adgangskode, som sendes til dig. Det kræver en begrundelse og noteres i en log. Linket gemmes ikke.")
});